export const METHODS = {
  GET: 'GET',
  POST: 'POST'
}
